// Module
var code = "<div data-bind=\"click: _help.ShowControlHelp.bind(_help, $data)\" class=\"ConsultScreenView EditScreenView iframe-control form-standart-control\"> <iframe data-bind=\"attr: {src: _url, height: _heightPX || ''}, css: {'isHeight': !!+_heightPX()}\" frameborder=\"0\" scrolling=\"no\" height=\"200\" class=\"iframe-element\"></iframe> </div>";
// Exports
export default code;